export default __webpack_public_path__ + "static/media/token_collaborative_logo.221e3808.png";